import { featuresData } from '@/mocks/homeData';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-16 md:py-24 bg-background-50">
      <div className="mx-auto max-w-[1400px] px-4 md:px-8">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-2">
            为什么选择麻花视频
          </h2>
          <div className="w-12 h-1 bg-primary-500 rounded-full mx-auto mb-4"></div>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            三大核心优势，打造极致追剧体验
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {featuresData.map((item) => (
            <div
              key={item.title}
              className="group p-8 rounded-2xl bg-background-100 border border-background-200/60 hover:border-primary-300/40 transition-all duration-300"
            >
              <div className="w-14 h-14 rounded-xl bg-primary-100 flex items-center justify-center mb-5 group-hover:bg-primary-500 transition-colors duration-300">
                <i className={`${item.icon} text-2xl text-primary-500 group-hover:text-background-50 transition-colors duration-300`}></i>
              </div>
              <h3 className="text-lg font-heading font-bold text-foreground-950 mb-3">{item.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}